module.exports = __webpack_public_path__ + "static/media/your-flower-art-PC.e2ffdf79.jpg";